import { InputGroup, FormControl } from 'react-bootstrap';
import arrowRight from '../../assets/images/svg/arrow-right-white.svg';
import './subscriptionInput.css';

function SubscriptionInput() {
  return (
    <div className="subscription_box">
      <InputGroup className="mb-3">
        <FormControl
          placeholder="Email Address"
          aria-label="Email Address"
          aria-describedby="basic-addon2"
        />
        <button type="button">
          <InputGroup.Text id="basic-addon2">
            <img src={arrowRight} alt="arrowRight" />
          </InputGroup.Text>
        </button>
      </InputGroup>
    </div>
  );
}

export default SubscriptionInput;
